import React from 'react';
import { drawerInfoProps } from '../../Evaluations';
import { Cards } from './components/Cards/Cards';
import { ProgressDetails } from './components/ProgressDetails/ProgressDetails';
import { useSelectBranchOffice } from './Content.hooks';

import { Container } from './Content.styles';

interface ContentProps {
	onChangeDrawerInfo: (e: drawerInfoProps) => void;
	campaignId: string;
}

export const Content = ({
	onChangeDrawerInfo,
	campaignId,
}: ContentProps): JSX.Element => {
	const { handleSelectBranchOfficeId, branchOfficeId } =
		useSelectBranchOffice();

	return (
		<Container>
			<ProgressDetails
				campaignId={campaignId}
				onSelectBranchOfficeId={handleSelectBranchOfficeId}
				selectedBranchOfficeId={branchOfficeId}
			/>
			<Cards
				variant={branchOfficeId === 'total' ? 'total' : 'detail'}
				selectedBranchOfficeId={branchOfficeId}
				campaignId={campaignId}
				onChangeDrawerInfo={onChangeDrawerInfo}
			/>
		</Container>
	);
};
